import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Alert, Button, Form, Input, Modal, Radio, Select, notification } from 'antd'
import queryString from "query-string"
import { listLevels, listPartner } from "../../../../services/api/3dApi"

const { TextArea } = Input
const { Option } = Select

class BatchRecycleV2 extends Component {
    constructor(props) {
        super(props)

        const { level, user, partner } = this.props

        this.state = {
            isOpen: false,
            loading: false,
            error: '',
            user: user || '',
            validate: '',
            errLevels: '',
            level: level || '1',
            levels: [],
            partner: (partner !== null && partner !== undefined) ? partner._id : '',
            partners: [],
            errPartner: '',
            string: '',
            items: [],
            errorMessages: []
        }
    }


    _showModal = () => {
        this.setState({
            isOpen: true,
            loading: false,
            error: '',
            validate: ''
        }, () => {
            this._fetchLevels()
            this._fetchPartners()
        })
    }

    _closeModal = () => {
        this.setState({
            isOpen: false,
            loading: false,
            error: '',
            validate: ''
        })
    }

    _checkItems = (itemNumber) => {
        const trimmed = typeof itemNumber === 'string' ? itemNumber.trim() : ''
        if (!trimmed) return false

        const barcode = trimmed.includes('#') ? trimmed : '#' + trimmed

        const regex = /#(\d+)_(\d+)/gi
        const parsed = regex.exec(barcode)

        return !(!parsed || parsed.length !== 3)
    }

    _handleChangeItems = e => {
        const { value } = e.target

        this.setState({
            string: value
        }, () => {
            const arr = this.state.string.split(/\r|\n|\t|\r\n|\s|,\s|,/)
            const newArr = arr.filter(item => item !== '' && this._checkItems(item))
            const uniqueTemplates = [...new Set(newArr)]

            this.setState({
                items: uniqueTemplates
            })
        })
    }

    _handleChangeInput = (e) => {
        const { value } = e.target

        this.setState({
            user: value
        })
    }

    _handleChange = (e) => {
        this.setState({
            level: e.target.value
        })
    }

    _handleChangePartner = (value) => {
        this.setState({
            partner: value
        })
    }

    _onRecycleBatch = async () => {
        this.setState({
            loading: true,
            error: '',
            forceRecreateBarcodes: []
        })

        try {
            const { id, recycleBatchV2 } = this.props
            const { user, level, partner, items } = this.state

            if (user === undefined || user === '') {
                this.setState({ loading: false, validate: 'Vui lòng nhập vào người tái tạo lô.' })
                return
            }

            const params = {
                user_create: user.trim(),
                level: level,
                partnerId: partner,
                forceRecreateBarcodes: items
            }

            const { data: response } = await recycleBatchV2(id, params)

            const { success, error, data } = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            this.setState({
                loading: false,
                errorMessages: data.errorMessages
            }, () => {
                const { errorMessages } = this.state

                this._closeModal()

                if (data.newBatch._id) {
                    const win = window.open(`/batches/${data.newBatch._id}`, "_blank")
                    win.focus()
                }

                if (errorMessages.length > 0) {
                    notification.error({
                        message: 'Lỗi',
                        description: errorMessages.map((item, index) => {
                            return <p className='mb-0' key={index}>{item}</p>
                        })
                    })
                }

                this.setState({
                    forceRecreateBarcodes: []
                })
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _fetchLevels = async () => {
        try {
            const { data: response } = await listLevels()

            const { success, error, data } = response

            if (!success) {
                this.setState({
                    errLevels: error
                })

                return
            }

            this.setState({
                errLevels: '',
                levels: data
            })
        } catch (e) {
            this.setState({})
        }
    }

    _fetchPartners = async () => {
        try {
            const payload = { type: 'print_partner' }
            const query = queryString.stringify(payload)

            const { data: response } = await listPartner(query)

            const { success, error, data } = response

            if (!success) {
                this.setState({
                    errPartner: error
                })

                return
            }

            this.setState({
                errPartner: '',
                partners: data.partners
            })
        } catch (e) {
            this.setState({})
        }
    }

    render() {
        const {
            isOpen,
            loading,
            user,
            error,
            validate,
            level,
            levels,
            errLevels,
            partners,
            errPartner,
            string,
            items
        } = this.state
        const { changeContent, partner = {}, title } = this.props

        return (
            <div className="BatchRecycle">
                <Button type='primary' className="mr-3 mt-2" icon='retweet' loading={loading}
                    onClick={this._showModal} disabled={changeContent}
                >
                    {title}
                </Button>
                <Modal
                    visible={isOpen}
                    title="Tái tạo lô"
                    onOk={this._onRecycleBatch}
                    onCancel={this._closeModal}
                    footer={[
                        <Button key="back" onClick={this._closeModal}>
                            Hủy
                        </Button>,
                        <Button key="submit" type="primary" loading={loading} onClick={this._onRecycleBatch}>
                            Tái tạo
                        </Button>
                    ]}
                >
                    {error && <Alert message={error} type='error' className='mb-3' />}

                    <Form.Item
                        label='Tên người tái tạo lô'
                        validateStatus={validate && 'error'}
                        help={validate}
                    >
                        <Input value={user} onChange={this._handleChangeInput} />
                    </Form.Item>

                    <Form.Item
                        label='Chọn đối tác'
                        validateStatus={errPartner && 'error'}
                        help={errPartner}
                    >
                        <Select onChange={this._handleChangePartner} defaultValue={partner._id}>
                            <Option value=''>---Hãy chọn một đối tác---</Option>
                            {
                                partners.length > 0 && partners.map(item => {
                                    return <Option key={item._id} value={item._id}>{item.name}</Option>
                                })
                            }
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label='Độ ưu tiên của lô'
                        validateStatus={errLevels && 'error'}
                        help={errLevels}
                    >
                        <Radio.Group onChange={this._handleChange} defaultValue={level}>
                            {
                                levels.length > 0 && levels.map(item => {
                                    return <Radio key={item.key} value={item.key}>{item.value}</Radio>
                                })
                            }
                        </Radio.Group>
                    </Form.Item>

                    {/* <Form.Item
                        label='Thêm item ngoại lệ(nhập từng dòng hoặc cách nhau bằng dấu phẩy)'
                    >
                        <TextArea rows={6} onChange={this._handleChangeItems}>{string}</TextArea>
                        <div className='mt-2'>
                            Đã nhập: <span className='font-weight-bold'>{items.length} items</span>
                        </div>
                    </Form.Item> */}
                </Modal>
            </div>
        )
    }
}

BatchRecycleV2.propTypes = {
    changeContent: PropTypes.bool.isRequired,
    user: PropTypes.string,
    id: PropTypes.string,
    partner: PropTypes.object
}

export default BatchRecycleV2
